import { Box, IconButton } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CloseIcon from '@mui/icons-material/Close';

const LogStatusChip = ({ status }) => {
  let bgColor = '#9e9e9e';
  let IconComponent = null;

  switch (status) {
    case 'Info':
      bgColor = '#4caf50';
      IconComponent = CheckIcon;
      break;

    case 'Warning':
      bgColor = '#ffeb3b';
      IconComponent = WarningAmberIcon;
      break;

    case 'Error':
      bgColor = '#f44336';
      IconComponent = CloseIcon;
      break;

    default:
      bgColor = '#9e9e9e';
      IconComponent = CloseIcon;
  }

  const Icon = IconComponent;

  return (
    <Box
      sx={{
        width: 22,
        height: 22,
        borderRadius: '50%',
        backgroundColor: bgColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        mt: 0.5,
        ml: 1.5,
      }}
    >
      <Icon sx={{ fontSize: 16 }} />
    </Box>
  );
};

export default LogStatusChip;
